import { Heart } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

// GotBackup/GVO opt-in: native form POST to www.gogvo.com/subscribe.php with
// ONLY the Campaign + AffiliateName hidden fields, restyled to the
// MyHeartGives palette (no GVO CSS). Opens their thank-you page in a new tab
// so visitors stay on our site. One shared style for every campaign form.
export const StayConnected = ({
  testidPrefix = "stay-connected",
  campaign = "A Giving Heart",
  eyebrow = "Keep in touch",
  heading = (
    <>
      Stay Connected to Your{" "}
      <span className="italic text-crimson">Community</span>
    </>
  ),
  subheading = "Leave your name and email, and we'll make sure you never miss a story worth hearing — or a neighbor worth helping.",
  buttonLabel = "Stay Connected",
}) => (
  <section className="bg-cream" data-testid={`${testidPrefix}-section`}>
    <div className="mx-auto max-w-xl px-4 py-16 text-center sm:px-6 lg:py-20">
      <Reveal>
        <Eyebrow className="text-center">{eyebrow}</Eyebrow>
        <h2
          className="mt-4 font-serif text-2xl font-bold tracking-tight text-ink sm:text-3xl lg:text-4xl"
          data-testid={`${testidPrefix}-heading`}
        >
          {heading}
        </h2>
        <p className="mt-4 text-base leading-relaxed text-cocoa">{subheading}</p>

        <form
          method="POST"
          action="https://www.gogvo.com/subscribe.php"
          target="_blank"
          rel="noopener"
          className="mt-8"
          data-testid={`${testidPrefix}-form`}
        >
          <input type="hidden" name="Campaign" value={campaign} />
          <input type="hidden" name="AffiliateName" value="jldelawderNLS" />

          <div className="flex flex-col gap-3 sm:flex-row">
            <input
              type="text"
              name="name"
              required
              placeholder="Your Name"
              aria-label="Your Name"
              className="w-full flex-1 rounded-full border border-line bg-white px-5 py-3.5 text-sm text-ink placeholder:text-taupe outline-none transition-colors focus:border-gold"
              data-testid={`${testidPrefix}-name-input`}
            />
            <input
              type="email"
              name="email"
              required
              placeholder="Enter Your Email"
              aria-label="Enter Your Email"
              className="w-full flex-1 rounded-full border border-line bg-white px-5 py-3.5 text-sm text-ink placeholder:text-taupe outline-none transition-colors focus:border-gold"
              data-testid={`${testidPrefix}-email-input`}
            />
            <button
              type="submit"
              className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full bg-crimson px-7 py-3.5 text-sm font-semibold text-ivory transition-all duration-200 hover:-translate-y-0.5 hover:bg-crimson-deep"
              data-testid={`${testidPrefix}-submit-button`}
            >
              {buttonLabel}
            </button>
          </div>
        </form>

        <p
          className="mt-8 flex items-center justify-center gap-2 font-serif text-lg italic text-gold"
          data-testid={`${testidPrefix}-tagline`}
        >
          <Heart className="h-4 w-4" fill="currentColor" />
          Touching one Heart to Another.
          <Heart className="h-4 w-4" fill="currentColor" />
        </p>
      </Reveal>
    </div>
  </section>
);
